
TS.ns('WL');

WL.leasingApplicationGeneralInfoModel = new Class({
    Extends: WL.leasingApplicationBaseModel,

    createProperties: function (config) {
        var me = this;

        me.parent(config);
        var clientList = me.getDomainProperty('browseClient_Property');
        var partnerList = me.getDomainProperty('browsePartner_Property');

        if (clientList != null) {
            clientList.on('selectionChanged', me.onClientChanged, me);
        }

        me.watchProperty(me.Document.ClientUniqueID, me.onClientUniqueIDChanged, me);

        if (partnerList != null) {
            partnerList.on('selectionChanged', me.onPartnerChanged, me);
        }
    },
   
    onClientChanged: function (selectedPartner) {
        var me = this;

        me.isPartnerChanging = true;

        if (selectedPartner.sender.SelectedItem() == null) {
            me.Document.ClientUniqueID(null);
        }
        else {
            setTimeout(function () {
                me.Document.ClientUniqueID(selectedPartner.sender.SelectedItem().UniqueID);
            }, 0);
        }

        me.isPartnerChanging = false;
    },

    onClientUniqueIDChanged: function (newValue) {
        var me = this;

        if (me.isPartnerChanging === true)
            return;

        me.performServerCommand('SearchPartner', true);
    },

    onPartnerChanged: function (selectedPartner) {
        var me = this;

        if (selectedPartner.sender.SelectedItem() == null) {
            me.Document.DocumentScoringAnalysis.EngineScoringId(null);
        }
        else {
            me.Document.DocumentScoringAnalysis.EngineScoringId(selectedPartner.sender.SelectedItem().EngineScoringId);
        }
        
        me.Document.LeasingPartnerRoleId(null);
        me.Document.LeasingPartnerRoleName(null);
    }

});

